import { createFileRoute } from '@tanstack/react-router'
import { GalleryPage } from '../components/pages/GalleryPage'
import { publicPageHead } from '../lib/seo'

export const Route = createFileRoute('/gallery')({
  component: GalleryPage,
  head: () => publicPageHead({
    title: 'Our Work | Autoglow Detailing Geelong',
    description:
      'Studio gallery from Autoglow Detailing in Drysdale — ceramic coating, paint correction and detailing work serving Geelong and the Bellarine.',
    path: '/gallery',
  }),
})
